module.exports = __webpack_public_path__ + "img/1515163363.3bade870.jpg";